import React, { useState, useEffect, Fragment } from 'react';
import { ProductQuantityConstants } from '../constants';
import { updateQuantity } from '../Actions/Cart.action';
import { useDispatch } from 'react-redux';

const ProductQuantityField = (props) => {
    const defaultQuantity = parseInt(props.minArticleQuantity) ?? 1;
    const dispatch = useDispatch();

    useEffect(() => {
        document.getElementById(
            ProductQuantityConstants.QuantityId
        ).value = defaultQuantity;
    }, [defaultQuantity]);

    const [quantity, setQuantity] = useState(defaultQuantity);

    const setQuantityInputField = (newValue) => {
        document.getElementById(
            ProductQuantityConstants.QuantityId
        ).value = newValue;
    };

    const increaseQuantity = () => {
        setQuantity((x) => x + defaultQuantity);
        setQuantityInputField(quantity + defaultQuantity);
        dispatch(
            updateQuantity(props.articleNumber, quantity + defaultQuantity)
        );
    };

    const decreaseQuantity = () => {
        if (quantity > defaultQuantity) {
            setQuantity((x) => x - defaultQuantity);
            setQuantityInputField(quantity - defaultQuantity);
            dispatch(
                updateQuantity(props.articleNumber, quantity - defaultQuantity)
            );
        }
    };

    const freelyChangeQuantity = (value) => {
        value = parseInt(value) ?? quantity;
        if (value >= defaultQuantity) {
            setQuantity(value);
        }
        dispatch(updateQuantity(props.articleNumber, value));
    };

    return (
        <Fragment>
            <a
                className={ProductQuantityConstants.ProductDetailQuantityButton}
                onClick={decreaseQuantity}
            >
                {ProductQuantityConstants.MinusSign}
            </a>
            {defaultQuantity !== 1 ? (
                <p
                    id={ProductQuantityConstants.QuantityId}
                    value={defaultQuantity}
                    className={
                        ProductQuantityConstants.ProductDetailQuantityInput
                    }
                >
                    {quantity}
                </p>
            ) : (
                <input
                    id={ProductQuantityConstants.QuantityId}
                    className={
                        ProductQuantityConstants.ProductDetailQuantityInput
                    }
                    type="text"
                    maxLength={3}
                    value={quantity.toString()}
                    onChange={(event) =>
                        freelyChangeQuantity(event.target.value)
                    }
                />
            )}

            <a
                className={ProductQuantityConstants.ProductDetailQuantityButton}
                onClick={increaseQuantity}
            >
                {ProductQuantityConstants.PlusSign}
            </a>
        </Fragment>
    );
};

export default ProductQuantityField;
